import moment from 'moment'
import 'moment-duration-format'

import * as actions from './actions'

import { patchOperations } from 'utils/PatchHelper'

import { api } from './api'
import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'

// convert local hours/minutes Record to 00:00:00 format
const mapSlotHours = teamAvailabilitySettings =>
  teamAvailabilitySettings.get('openHours').map(slot => {
    return {
      dayOfWeek: slot.dayOfWeek,
      opens: moment
        .duration({ hours: slot.startTime.hour, minutes: slot.startTime.minutes })
        .format('HH:mm:ss', { trim: false }),
      closes: moment.duration({ hours: slot.endTime.hour, minutes: slot.endTime.minutes }).format('HH:mm:ss', { trim: false })
    }
  })

const fetchOrgTeams = action$ =>
  action$
    .ofType(actions.fetchOrgTeams.toString())
    .pluck('payload')
    .mergeMap(() => {
      return api
        .fetchTeams()
        .map(response => actions.fetchOrgTeamsSuccess(response))
        .startWith(actions.fetchOrgTeamsPending())
        .catch(error => {
          return Observable.of(actions.fetchOrgTeamsFailed({ error }))
        })
    })

const patchOrgTeam = action$ =>
  action$
    .ofType(actions.patchOrgTeam.toString())
    .pluck('payload')
    .mergeMap(({ teamId, properties }) => {
      return api
        .patchTeam({ teamId, properties })
        .map(teamSettings => actions.patchOrgTeamSuccess({ teamId, team: teamSettings }))
        .startWith(actions.patchOrgTeamPending())
        .catch(error => Observable.of(actions.patchOrgTeamFailed(error)))
    })

const deleteOrgTeam = action$ =>
  action$
    .ofType(actions.deleteOrgTeam.toString())
    .pluck('payload')
    .mergeMap(({ teamId }) => {
      const payload = patchOperations({
        status: 'ARCHIVED',
      })
      return api
        .patchTeam({ teamId, properties: payload })
        .map(() => actions.deleteOrgTeamSuccess())
        .startWith(actions.deleteOrgTeamPending())
        .catch(error => Observable.of(actions.deleteOrgTeamFailed(error)))
    })

const createOrgTeam = action$ =>
  action$
    .ofType(actions.createOrgTeam.toString())
    .pluck('payload')
    .mergeMap(({ team }) => {
      return api
        .createTeam({ team })
        .map(() => actions.createOrgTeamSuccess())
        .startWith(actions.createOrgTeamPending())
        .catch(error => Observable.of(actions.createOrgTeamFailed(error)))
    })

const fetchTeamsForUser = action$ =>
  action$
    .ofType(actions.fetchTeamsForUser.toString())
    .pluck('payload')
    .mergeMap(({ userId }) => {
      return api
        .fetchTeamsForUser({ userId })
        .map(response => actions.fetchTeamsForUserSuccess({ userId: userId, teams: response }))
        .startWith(actions.fetchTeamsForUserPending())
        .catch(error => {
          return Observable.of(actions.fetchTeamsForUserFailed({ error }))
        })
    })

const fetchTeamAvailabilities = action$ =>
  action$
    .ofType(actions.fetchTeamAvailabilities.toString())
    .pluck('payload')
    .mergeMap(() => {
      return api
        .fetchTeamAvailabilities()
        .map(response => actions.fetchTeamAvailabilitiesSuccess(response))
        .startWith(actions.fetchTeamAvailabilitiesPending())
        .catch(error => {
          return Observable.of(actions.fetchTeamAvailabilitiesFailed({ error }))
        })
    })

const fetchTeamAvailability = action$ =>
  action$
    .ofType(actions.fetchTeamAvailability.toString())
    .pluck('payload')
    .mergeMap(({ availabilityId }) => {
      return api
        .fetchTeamAvailability({ availabilityId })
        .map(response =>
          actions.fetchTeamAvailabilitySuccess({ availabilityId, teamAvailabilitySettings: response })
        )
        .startWith(actions.fetchTeamAvailabilityPending())
        .catch(error => {
          return Observable.of(actions.fetchTeamAvailabilityFailed({ error }))
        })
    })

const createTeamAvailability = action$ =>
  action$
    .ofType(actions.createTeamAvailability.toString())
    .pluck('payload')
    .mergeMap(({ teamAvailabilitySettings }) => {
      return api
        .createTeamAvailability({ teamAvailabilitySettings })
        .map(response =>
          actions.createTeamAvailabilitySuccess({
            teamAvailabilitySettings: response,
          })
        )
        .startWith(actions.createTeamAvailabilityPending())
        .catch(error => {
          return Observable.of(actions.createTeamAvailabilityFailed({ error }))
        })
    })

const updateAvailabilityForTeam = action$ =>
  action$
    .ofType(actions.updateAvailabilityForTeam.toString())
    .pluck('payload')
    .mergeMap(({ teamId, teamAvailabilitySettings }) => {
      const settings = !teamAvailabilitySettings
        ? null
        : teamAvailabilitySettings.set('openHours', mapSlotHours(teamAvailabilitySettings))
      return api
        .updateAvailabilityForTeam({ teamId, teamAvailabilitySettings: settings })
        .map(response =>
          actions.updateAvailabilityForTeamSuccess({ teamId, teamAvailabilitySettings: response })
        )
        .startWith(actions.updateAvailabilityForTeamPending())
        .catch(error => {
          return Observable.of(actions.updateAvailabilityForTeamFailed({ error }))
        })
    })

const updateTeamAvailability = action$ =>
  action$
    .ofType(actions.updateTeamAvailability.toString())
    .pluck('payload')
    .mergeMap(({ teamAvailabilityId, teamAvailabilitySettings }) => {
      return api
        .updateTeamAvailability({ teamAvailabilityId, teamAvailabilitySettings })
        .map(response =>
          actions.updateTeamAvailabilitySuccess({ teamAvailabilityId, teamAvailabilitySettings: response })
        )
        .startWith(actions.updateTeamAvailabilityPending())
        .catch(error => {
          return Observable.of(actions.updateTeamAvailabilityFailed({ error }))
        })
    })

export const epic = combineEpics(
  fetchOrgTeams,
  patchOrgTeam,
  deleteOrgTeam,
  createOrgTeam,
  updateAvailabilityForTeam,
  fetchTeamsForUser,
  fetchTeamAvailabilities,
  fetchTeamAvailability,
  createTeamAvailability,
  updateTeamAvailability
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/teams/epic.js